import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { TenantResponse } from 'src/types/rest/tenant';

export const useTenant = (
  tenantId?: string,
  options?: Partial<UseQueryOptions<TenantResponse>>,
) => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useQuery({
    queryFn: () =>
      apiRequest<TenantResponse>({
        url: `${apiHost}/tenants/${tenantId}`,
      }),
    queryKey: ['tenant', tenantId],
    ...options,
    /**
     * Combined explicitly so a caller-provided `enabled` (e.g. gating on
     * authorization) can't accidentally re-enable the query when there's no
     * id to fetch.
     */
    enabled: !!tenantId && (options?.enabled ?? true),
  });
};
